export function thrower(msg: string) {
  throw new Error(msg);
}

export function prefixedThrower(prefix: string) {
  return (msg: string) => thrower(`${prefix}${msg}`);
}